export const getWebGL = t => {
  const canvas = document.createElement("canvas");
  const gl =
    canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

  if (!gl) {
    return {
      webGLVendor: t("global.notSupported"),
      webGLRenderer: t("global.notSupported"),
      details: [
        { indicator: "0", description: `WebGL ${t("global.notSupported")}` },
      ],
    };
  }

  const webGLVendor = gl.getParameter(gl.VENDOR) || t("global.notSupported");
  const webGLRenderer =
    gl.getParameter(gl.RENDERER) || t("global.notSupported");

  const extensions = gl.getSupportedExtensions().length;
  const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
  const maxVertexTextureImageUnits = gl.getParameter(
    gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS,
  );
  const maxFragmentUniformVectors = gl.getParameter(
    gl.MAX_FRAGMENT_UNIFORM_VECTORS,
  );
  const vertexShaderPrecision = gl.getShaderPrecisionFormat(
    gl.VERTEX_SHADER,
    gl.HIGH_FLOAT,
  ).precision;
  const fragmentShaderPrecision = gl.getShaderPrecisionFormat(
    gl.FRAGMENT_SHADER,
    gl.HIGH_FLOAT,
  ).precision;

  const webGLParameters = [
    {
      indicator: extensions,
      description: t("scannerFingerprint.webGLParameters.extensions"),
    },
    {
      indicator: maxTextureSize,
      description: t("scannerFingerprint.webGLParameters.maxTextureSize"),
    },
    {
      indicator: maxCubemapSize,
      description: t("scannerFingerprint.webGLParameters.maxCubemapSize"),
    },
    {
      indicator: maxVertexTextureImageUnits,
      description: t(
        "scannerFingerprint.webGLParameters.maxVertexTextureImageUnits",
      ),
    },
    {
      indicator: maxFragmentUniformVectors,
      description: t(
        "scannerFingerprint.webGLParameters.maxFragmentUniformVectors",
      ),
    },
    {
      indicator:
        vertexShaderPrecision !== undefined
          ? vertexShaderPrecision
          : t("global.notSupported"),
      description: t(
        "scannerFingerprint.webGLParameters.vertexShaderPrecision",
      ),
    },
    {
      indicator:
        fragmentShaderPrecision !== undefined
          ? fragmentShaderPrecision
          : t("global.notSupported"),
      description: t(
        "scannerFingerprint.webGLParameters.fragmentShaderPrecision",
      ),
    },
  ];

  return { webGLVendor, webGLRenderer, webGLParameters };
};
